import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const SearchIcon = props => (
    <SvgIcon {...props} viewBox="0 0 18 18">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.4406 16.3963L9.90505 11.7463C8.81754 12.4619 7.51093 12.7424 6.23444 12.5343C4.95795 12.3262 3.80092 11.644 2.98402 10.6179C2.16711 9.59177 1.7475 8.29352 1.80524 6.97076C1.86298 5.64801 2.39402 4.39331 3.29706 3.44598C4.20011 2.49865 5.41196 1.92499 6.70149 1.83441C7.99102 1.74383 9.26798 2.14269 10.2888 2.95488C11.3096 3.76708 12.0029 4.93578 12.2363 6.23809C12.4698 7.54039 12.2271 8.88516 11.5545 10.0159L16.2 14.7746L14.4406 16.3963ZM10.0027 10.4483L14.4764 15.0342L14.8001 14.7363L10.3042 10.13L10.5447 9.78914C11.18 8.88861 11.4592 7.77518 11.3263 6.67246C11.1933 5.56975 10.658 4.5594 9.82781 3.84432C8.99764 3.12924 7.93409 2.7624 6.85078 2.81745C5.76747 2.8725 4.7446 3.34537 3.98759 4.14111C3.23059 4.93684 2.79549 5.99651 2.76971 7.10729C2.74393 8.21808 3.12937 9.29773 3.8486 10.1294C4.56783 10.9611 5.56759 11.4833 6.64712 11.591C7.72666 11.6987 8.80602 11.3841 9.66843 10.7102L10.0027 10.4483Z"
        />
    </SvgIcon>
);

export default SearchIcon;
